/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-207381803-1",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Abdul Baasith",
  logo_name: "Abdul",
  nickname: "De_V!per",
  full_name: "Abdul Baasith Shiyam",
  subTitle:
    "Full Stack Developer, Machine Learning and Data science Enthusiast 🔥. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1f0jJo6GVODJWp6QTKU41yeq3iQOUPLGV/view?usp=sharing",
  mail: "mailto:baasith.shiyam1@gmail.com@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/baasithshiyam",
  linkedin: "https://www.linkedin.com/in/shiyam-baasith-4666241a6/",
  gmail: "baasith.shiyam1@gmail.com",
  gitlab: "https://gitlab.com/baasith",
  twitter: "https://twitter.com/abdulBa18033192",
  instagram: "https://www.instagram.com/_baasith._/",
};

const skills = {
  data: [
    {
      title: "Full Stack Develouper & Machine Learning Enthusiast",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using Flutter and React Native",
        "⚡ Creating application backend in Django, Spring boot & Flask",
        "⚡ Creating machine learning application ",
        "⚡ Creating data analysis and machine learning algorithum ",
        "⚡ Integration of third party services such as Firebase/ AWS / Consul"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Dart",
          fontAwesomeClassname: "simple-icons:dart",
          style: {
            color: "#29B0EE",
          },
        },
        // {
        //   skillName: "Visual Basic",
        //   fontAwesomeClassname: "simple-icons:dot-net",
        //   style: {
        //     color: "#029FCE",
        //   },
        // },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        // {
        //   skillName: "C++",
        //   fontAwesomeClassname: "simple-icons:cplusplus",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Westminster UK",
      subtitle: "B.Eng Software Engineering",
      logo_path: "uow.png",
      alt_name: "SETI",
      duration: "2019 - 2024",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Machine Learning, Programming etc.",
        "⚡ I have also completed various online courses for Machine Learning and data science ,Backend , Mobile App Development and Web, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "https://www.westminster.ac.uk/",
    },
    {
      title: "Zahira college Colobo",
      subtitle: "Advance Level A/L  & Ordinary Level O/L",
      logo_path: "zcc.jpg",
      alt_name: "zahira",
      duration: "2006 - 2019",
      descriptions: [
        "⚡ Advance Level Results = Information Technology : \"A\" , Business Studies : \"B\" , Accounting : \"A\"" ,
        "⚡ I am also a president awarded Scout ",
        "⚡ Senior Swimmer",
        "⚡ played U18 basketball team",
        "⚡ Ordinary level =  1A ,2B ,5C ",
      ],
      website_link: "https://www.zahiracollege.lk/about/logo",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Data Science Orientation",
      subtitle: "IBM",
      logo_path: "ibm.png",
      certificate_link:
        "https://www.credly.com/badges/a4b086c2-5d38-45b2-83e5-ae78346c6ec1/public_url",
      alt_name: "Data Science Orientation",
      // color_code: "#2AAFED",
      color_code: "#47A048",
    },
    {
      title: "React (Basic) Certificate",
      subtitle: "Hacker Rank",
      logo_path: "hackerrankjava.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/2400e036ecd2",
      alt_name: "hackathon",
      color_code: "#E2405F",
    },
    {
      title: "Java (Basic) Certificate",
      subtitle: "Hacker Rank",
      logo_path: "hackerrankjava1.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/1f3bec68fda6",
      alt_name: "Java (Basic) Certificate",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },
    {
      title: "Python Programming & Software Design For Absolute Beginners",
      subtitle: "udemy",
      logo_path: "uddemypy.jpg",
      certificate_link:
        "https://drive.google.com/file/d/11Rm0hWuSD137koCcic8F2Wo6VGNG046Q/view?usp=sharing",
      alt_name: "Python Programming & Software Design For Absolute Beginners",
      color_code: "#2AAFED",
    },
    {
      title: "Ultimate Adobe Photoshop CC Masterclass Basics To Advanced",
      subtitle: "udemy",
      logo_path: "photoshop.jpg",
      certificate_link:
        "https://drive.google.com/file/d/17i16RL3LDlSiki8LsE-t7ErX55I53CTp/view?usp=sharing",
      alt_name: "Ultimate Adobe Photoshop CC Masterclass Basics To Advanced",
      color_code: "#fe0037",
    },
    {
      title: "Machine Learning Foundations: A Case Study Approach",
      subtitle: "cousera",
      logo_path: "cosera.jpeg",
      certificate_link:
        "https://coursera.org/share/45ed95df70465bae25305e6066177002",
      alt_name: "Machine Learning Foundations: A Case Study Approach",
      color_code: "#2AAFED",
    },
    {
      title: "IRT HACK 2021",
      logo_path: "iet.png",
      subtitle: "IET HACK",
      certificate_link:
        "https://drive.google.com/file/d/10wQ768ayw5KJcobexiTePsXctvDj7g9P/view?usp=sharing",
      alt_name: "IET",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Applied Machine Learning: Foundations",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1jhB7rCw_BuvrUTc5iRQKR6yG4xTCcbfO/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#47A048",
    },
    {
      title: "Artificial Intelligence Foundations: Neural Networks",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1TSlQxsAlU9FXIweXZ_M87jhN2Z_4zBzW/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#E2405F",
    },
    {
      title: "Building Modern Projects with React",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1IVAzJXtvfvzyvKAtAgwUgSeZ8jqNjOfn/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#2AAFED",
    },
    {
      title: "Ethical Hacking with JavaScript",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1dvGiVTvpL0zee7b3URxpvr6xNLdJaKfN/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    

    //
    {
      title: "Flutter: Part 01 Introduction",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1ejCM0okIOeSqTYlcfHweyrPqI_zKXBe5/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#47A048",
    },
    {
      title: "Flutter: Part 02 Building Apps",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/14mhv1xmQocWfK0vkU8BY_BBd4XuOoxa-/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#E2405F",
    },
    {
      title: "Flutter: Part 03 Flutter Widgets",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1v7-JGddhfGFb2qdfuRh7Kzmi0oRzHj7j/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#2AAFED",
    },
    {
      title: "Java 11+ Essential Training",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1NgVTqvLMq-zQvFLgu7bUDlEbz5X-MYfs/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    

    //

    {
      title: "React Native: Building Mobile Apps",
      logo_path: "linkedin.jpg",
      subtitle: "Linkedin",
      certificate_link:
        "https://drive.google.com/file/d/1P2BZ-7EEDNqXHzwUMO-2a5sz-CxbMijX/view?usp=sharing",
      alt_name: "linkedin certificate",
      // color_code: "#f36c3d",
      color_code: "#47A048",
    },

  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've currentlyworking as a intern at hsenid mobile sollutions. I've mostly done projects on my own and as groups too . I love writing blogs to share my knowledge with others. Iam passionate about data science and machine Learning ",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Full Stack Developer (Intern)",
          company: "Hsenid mobile sollution",
          company_url: "https://www.hsenidmobile.com/",
          logo_path: "hsenid.jpeg",
          duration: "jun 2021 - currently",
          location: "Work From Home",
          description:
            "I worked on the project on ML mobile portal for which is used to reload and also ezcash and worked on Commericial bank application for remitance",
          color: "#0071C5",
        },
        {
          title: "Full Stack Developer (Freelancer)",
          company: "codeDot",
          company_url: "#",
          logo_path: "code.jpeg",
          duration: "MAY 2021 - Present",
          location: "Work From Home",
          description:
            "A self made start up where we do web apps and mobile app for tailor made custom software ",
          color: "#ee3c26",
        }
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Zahira College Scout",
          company: "ZCC",
          company_url: "https://www.facebook.com/groups/zahirascout/",
          logo_path: "zahira.jpeg",
          duration: "Feb 2013 - Present",
          location: "School",
          description:
            "A president awarded scout who is now volunteering as a assistance scout master",
          color: "#4285F4",
        },
        {
          title: "GitHub Student Developer",
          company: "GitHub",
          company_url: "https://github.com/",
          logo_path: "github.png",
          duration: "Feb 2019 - Present",
          location: "Work from Home",
          description:
          "Contribute to Open Source Community and Open Source Project in cyber security",
          color: "#040f26",
        },
        {
          title: "Google Local Guide",
          company: "Google Map",
          company_url: "https://maps.google.com/localguides/",
          logo_path: "localguide.png",
          duration: "Sep 2018 - Present",
          location: "Work From Home",
          description:
            "Writes review on the places i travel and help local business in improving the travel ",
          color: "#D83B01",
        },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create Data science and Machine learning Models, Python   Scripts, and React Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "abdul.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I write blog frequently which i share my knowledge in the fireld of Data sciend and Machine learning . I too write on software develoupment project and topics on cyber securtiy . I write on Twitter too.",
    link: "https://baasith-shiyam1.medium.com/",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Creit Mart ",
      url: "https://www.youtube.com/watch?v=RFgPru2Vho4&t=8s",
      description: "Represented the team ‘Team 50 cent. This mainly focused on Credit risk analysis in financial sector. We made A web application in-order to analyze the financial capabilities, predicts the credit limit affordable during a credit transaction",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "1",
      name: "React Native Todo app",
      url: "https://www.youtube.com/watch?v=ROdGwn_e4aA",
      description:
        "A React Native todo appilication with redux used as store.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "React native",
          iconifyClass: "logos-react",
        },
        {
          name: "Redux",
          iconifyClass: "logos:redux",
        },
      ],
    },
    {
      id: "2",
      name: "Chatting app",
      url: "https://github.com/baasithshiyam/chatting-app",
      description:
        "A simple cahatting app using react native and firebase.",
      languages: [
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
        {
          name: "Flutter",
          iconifyClass: "logos:flutter",
        },
      ],
    },
    {
      id: "3",
      name: "Static Computer Shop site",
      url: "https://github.com/baasithshiyam/FrontendResponsivePage",
      description:
        "A static web page that is responsive both mobile and web done in html and css and javascript",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        
      ],
    },
    {
      id: "4",
      name: "Nureal network for USD price ",
      url: "https://github.com/baasithshiyam/Nurealnet_R",
      description:
        "A model using nureal net to identify the future of USD fluctualtion done in R",
      languages: [
        {
          name: "R",
          iconifyClass: "logos:jupyter",
        },
       
      ],
    },
    {
      id: "5",
      name: "Vechile Clustering ",
      url: "https://github.com/baasithshiyam/Clustering_using_R",
      description:
        "a model that is used to cluster vechiles as van car and other catogories with the help of clustering k -means algorithum in R",
      languages: [
        {
          name: "R",
          iconifyClass: "logos:jupyter",
        },
      ],
    },
    {
      id: "6",
      name: "Find the shortest Root",
      url: "https://github.com/baasithshiyam/20195666_Algo_CW",
      description:
        "A simple command line application that is used to calculate the shortest path using FordFulkerson algorithum in java",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos:java",
        },
        
      ],
    },
    {
      id: "7",
      name: "Football leage manager ",
      url: "https://github.com/baasithshiyam/FootballLeague",
      description:
        "A application done using java backend and angular as frontend and used play framework",
      languages: [
        {
          name: "angular",
          iconifyClass: "logos:angular-icon",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Java",
          iconifyClass: "logos:java",
        },  
        {
          name: "play",
          iconifyClass: "logos:play",
        },
      ],
    },
    {
      id: "6",
      name: "Gym management system",
      url: "https://github.com/baasithshiyam/",
      description:
        "A computerized system which help gym owners to keep records of their gym members. Technologies – Java, JavaFx",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos:java",
        }, 
      ],
    },
    {
      id: "7",
      name: "Financial Calculator ",
      url: "https://github.com/baasithshiyam/Java_CW_Assignment1",
      description:
        "A application that used to calculate the fianacial values .A computerize system which helps users to proceed their financial calculations Technologies - Java, JavaFx",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos:java",
        }, 
      ],
    },
    {
      id: "8",
      name: "image classification using deep learning",
      url: "https://gist.github.com/baasithshiyam/f3b3dcd981806f055f04fd46679af564",
      description:
        "A song recomendation system using transfer learning using turicreate",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "jupyter notebook",
          iconifyClass: "logos:jupyter",
        },
        
      ],
    },
    {
      id: "9",
      name: "Song recomendation model",
      url: "https://gist.github.com/baasithshiyam/043d15d2219a74f81a44f35068d1d072",
      description:
        "a song recommendation model using classification using the feature extraction ",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "jupyter notebook",
          iconifyClass: "logos:jupyter",
        },
        
      ],
    },
    {
      id: "10",
      name: "Sentimaental analysis model",
      url: "https://gist.github.com/baasithshiyam/02ddd4c302956720d16c4d1d51e9c687",
      description: "a sentimental analysis model for the product with specific recomendation",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "jupyter notebook",
          iconifyClass: "logos:jupyter",
        },
      ],
    },
    {
      id: "11",
      name: "House price prediction model",
      url: "https://gist.github.com/baasithshiyam/d75f71759727a0293f5fdc7247d05fab",
      description: "a regression analysis model for the house prices in US for finding new house prices by using feature extraction",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "jupyter notebook",
          iconifyClass: "logos:jupyter",
        },
      ],
    },
    
    {
      id: "12",
      name: "Rooted phone detector",
      url: "https://github.com/baasithshiyam/rooted-phone",
      description: "A simple react native app that can identify rooted phone .",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "React native",
          iconifyClass: "logos:react",
        },
      ],
    },
     
    {
      id: "12",
      name: "Invisible Cloak",
      url: "https://youtu.be/yAK0wLlvPHM",
      description: "A model that can detetct and eplace colors which makes aperson invisble using opencv and python .",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "jupyter notebook",
          iconifyClass: "logos:jupyter",
        },
      ],
    },
  ],
};


export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
